export default (state = {}, action) => {
  switch (action.type) {
    case 'PANEL_GET_PUNCHOUT_RULES': {
      return { ...state, punchOutRules: action.punchOutRules };
    }
    default:
      return state;
  }
};
